<!-- @format -->

<template>
	<!-- Mismo paginador del gestor de certplag: flechas, número editable y el
	     detalle de filtrados sobre el total del período. -->
	<div class="paginador mt-2">
		<div class="d-flex align-end">
			<v-btn
				small
				:elevation="pagina === 1 || cargando ? 2 : 0"
				:disabled="pagina === 1 || cargando"
				class="my-2 mr-2 py-1"
				aria-label="Página anterior"
				@click="$emit('pagina', pagina - 1)"
			>
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>

			<v-text-field
				v-model.number="paginaLocal"
				class="mx-1 my-2 centered-input"
				type="number"
				dense
				filled
				hide-details
				style="max-width: 60px; min-height: 32px"
				:disabled="cargando"
				@change="cambiarPagina"
			/>

			<v-btn
				small
				:elevation="pagina >= totalPaginas || cargando ? 2 : 0"
				:disabled="pagina >= totalPaginas || cargando"
				class="ml-2 my-2 mr-4"
				aria-label="Página siguiente"
				@click="$emit('pagina', pagina + 1)"
			>
				<v-icon>mdi-chevron-right</v-icon>
			</v-btn>

			<div class="control-filtro">
				<div class="control-filtro__label">OT por página</div>
				<v-select
					:value="cantidad"
					:items="[10, 25, 50, 100]"
					dense
					filled
					hide-details
					height="35px"
					style="max-width: 90px"
					:disabled="cargando"
					@change="valor => $emit('cantidad', valor)"
				/>
			</div>
		</div>
		<div class="paginador__detalle text-left">
			Página: {{ pagina }} de {{ totalPaginas }} (Filtrados: {{ total }} | Total del período:
			{{ totalGeneral }})
		</div>
	</div>
</template>

<script>
export default {
	name: 'WorkOrderPaginador',
	props: {
		pagina: { type: Number, default: 1 },
		cantidad: { type: Number, default: 25 },
		total: { type: Number, default: 0 },
		totalGeneral: { type: Number, default: 0 },
		cargando: { type: Boolean, default: false },
	},
	data() {
		return { paginaLocal: this.pagina };
	},
	computed: {
		totalPaginas() {
			return Math.max(1, Math.ceil(this.total / this.cantidad));
		},
	},
	watch: {
		pagina(nuevo) {
			this.paginaLocal = nuevo;
		},
	},
	methods: {
		cambiarPagina(valor) {
			const numero = Math.min(Math.max(1, Number(valor) || 1), this.totalPaginas);
			this.paginaLocal = numero;
			if (numero !== this.pagina) this.$emit('pagina', numero);
		},
	},
};
</script>

<style lang="scss" scoped>
.paginador {
	max-width: 1500px;
	margin: 0 auto;
	padding: 0 13px;
}

.control-filtro {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}

.control-filtro__label {
	font-size: 13px;
	font-weight: 500;
	color: #37474f;
	line-height: 1.2;
	margin-bottom: 4px;
	text-align: left;
}

.paginador__detalle {
	font-size: 12px;
	color: #607d8b;
}

.centered-input ::v-deep input {
	text-align: center;
}
</style>
